import { useState } from "react";
import {
  Avatar,
  Box,
  IconButton,
  TextField,
  Tooltip,
  Card,
  CardHeader,
  Divider,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
// import { Photograph as PhotographIcon } from "../../../icons/photograph";
// import { PaperClip as PaperClipIcon } from "../../../icons/paper-clip";

const AddComment = ({ onCreate, displayName, photoURL }) => {
  const [comment, setComment] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onCreate(comment);
    setComment("");
  };

  return (
    // <form onSubmit={handleSubmit} className="add__comment">
    //   <input
    //     type="text"
    //     className="comment__text"
    //     name="content"
    //     placeholder="Enter Comment...."
    //     value={comment}
    //     onChange={(e) => setComment(e.target.value)}
    //   />
    //   <input type="submit" value="Create Comment" />
    // </form>
    <Card elevation={0} style={{ marginBottom: "30px" }}>
      <Box
        sx={{
          alignItems: "center",
          backgroundColor: "background.paper",
          display: "flex",
          flexShrink: 0,
          p: 3,
        }}
        // {...other}
      >
        {/* --- AVATAR --- */}

        {/* {photoURL ? (
        <Avatar
          style={{
            width: "40px",
            height: "40px",
          }}
        >
          <img src={photoURL} width="40px" alt={displayName} />
        </Avatar>
      ) : (
        <Avatar alt="Remy Sharp" src={photoURL} />
      )} */}
        <TextField
          // disabled={disabled}
          fullWidth
          placeholder="Leave a message"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          size="small"
        />

        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            m: -2,
            ml: 2,
          }}
        >
          <Tooltip title="Send">
            <Box sx={{ m: 1 }}>
              <IconButton
                type="submit"
                color="primary"
                // disabled={!body || disabled}
                sx={{
                  backgroundColor: "primary.main",
                  color: "primary.contrastText",
                  "&:hover": {
                    backgroundColor: "primary.dark",
                  },
                }}
                onClick={handleSubmit}
              >
                <SendIcon fontSize="small" />
              </IconButton>
            </Box>
          </Tooltip>
          {/* <Tooltip title="Attach photo">
          <Box
            sx={{
              display: {
                xs: "none",
                sm: "inline-flex",
              },
              m: 1,
            }}
          >
            <IconButton disabled={disabled} edge="end" onClick={handleAttach}>
              <PhotographIcon fontSize="small" />
            </IconButton>
          </Box>
        </Tooltip> */}
          {/* <Tooltip title="Attach file">
          <Box
            sx={{
              display: {
                xs: "none",
                sm: "inline-flex",
              },
              m: 1,
            }}
          >
            <IconButton disabled={disabled} edge="end" onClick={handleAttach}>
              <PaperClipIcon fontSize="small" />
            </IconButton>
          </Box>
        </Tooltip> */}
        </Box>
        {/* <input hidden ref={fileInputRef} type="file" /> */}
      </Box>
    </Card>
  );
};

export default AddComment;
